import React, { useRef } from 'react';
import OwlCarousel from 'react-owl-carousel';
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';

import user1 from "../assets/images/reviews/aman.webp";
import user2 from "../assets/images/reviews/debasish.webp";
import user3 from "../assets/images/reviews/shiv.webp";
import user4 from "../assets/images/reviews/soumojit.webp";
import user5 from "../assets/images/reviews/subhendu.webp";
import user6 from "../assets/images/reviews/pritam.webp";

const ReviewsSection = () => {
    const carouselRef = useRef(null);

    const owlOptions = {
        loop: true,
        margin: 20,
        nav: false,
        dots: true,
        autoplay: true,
        smartSpeed: 3000,
        autoplayTimeout: 6000,
        responsive: {
            0: { items: 1 },
            991: { items: 2 },
            1281: { items: 3 },
        },
    };

    const handlePrev = () => {
        carouselRef.current.prev();
    };

    const handleNext = () => {
        carouselRef.current.next();
    };

    const reviews = [
        {
            id: 1,
            rating: 5,
            title: "Outstanding Execution",
            review: "Rahul delivered the project on time with excellent attention to detail. His ability to transform ideas into functional designs made the entire process seamless and stress-free.",
            name: "Subhendu",
            role: "Manager",
            avatar: user5,
        },
        {
            id: 2,
            rating: 5,
            title: "Highly Impressed",
            review: "Rahul handled our full-stack project efficiently. His communication, creativity, and technical skills ensured a smooth and successful outcome. Highly recommend working with him.",
            name: "Soumyajit",
            role: "Manager",
            avatar: user4,
        },
        {
            id: 3,
            rating: 5,
            title: "Trusted Developer",
            review: "Rahul was dependable throughout the project. He delivered high-quality results with a great attitude and clear understanding of our requirements. Would definitely work with him again.",
            name: "Debasish",
            role: "Business Owner",
            avatar: user2,
        },
        {
            id: 4,
            rating: 5,
            title: "Smooth Collaboration",
            review: "Rahul quickly understood our needs and delivered a polished product. His professionalism, patience, and responsiveness made the entire collaboration smooth and productive.",
            name: "Shiv Mukti",
            role: "Proprietor",
            avatar: user3,
        },
        {
            id: 5,
            rating: 5,
            title: "Clean & Stylish Work",
            review: "Rahul’s UI work stands out-clean, stylish, and perfectly aligned with our brand. He’s quick, reliable, and knows how to create an engaging visual experience.",
            name: "Pritam",
            role: "Videographer",
            avatar: user6,
        },
        {
            id: 6,
            rating: 5,
            title: "Reliable Partner",
            review: "Rahul is my go-to developer. Always delivers on time, communicates well, and produces high-quality, bug-free work. A reliable partner for any digital project.",
            name: "Aman",
            role: "Business Owner",
            avatar: user1,
        },
    ];

    return (
        <section
            id="reviews"
            className="py-24 bg-background-light dark:bg-background-dark border-t border-gray-100 dark:border-gray-800 scroll-mt-20 overflow-hidden"
        >
            <div className="w-[90%] mx-auto">
                <div className="flex flex-col md:flex-row justify-between items-end mb-16 gap-8">
                    <div className="reveal">
                        <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-primary/10 text-primary text-xs font-bold uppercase tracking-widest font-display mb-4">
                            <span className="relative flex h-2 w-2">
                                <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-primary opacity-75"></span>
                                <span className="relative inline-flex rounded-full h-2 w-2 bg-primary"></span>
                            </span>
                            Testimonials
                        </div>
                        <h2 className="text-4xl md:text-5xl font-bold text-[#0d121b] dark:text-white font-display tracking-tight">
                            Trusted by Founders & Teams
                        </h2>
                    </div>

                    <div className="reveal reveal-delay-1 flex gap-4">
                        <button
                            onClick={handlePrev}
                            className="size-14 rounded-2xl border border-gray-200 dark:border-gray-800 flex items-center justify-center hover:bg-primary hover:text-white hover:border-primary transition-all duration-300 shadow-soft group"
                        >
                            <span className="material-symbols-outlined group-active:-translate-x-1 transition-transform">
                                arrow_back
                            </span>
                        </button>
                        <button
                            onClick={handleNext}
                            className="size-14 rounded-2xl border border-gray-200 dark:border-gray-800 flex items-center justify-center hover:bg-primary hover:text-white hover:border-primary transition-all duration-300 shadow-soft group"
                        >
                            <span className="material-symbols-outlined group-active:translate-x-1 transition-transform">
                                arrow_forward
                            </span>
                        </button>
                    </div>
                </div>

                {/* --- Responsive OwlCarousel Container --- */}
                <div className="reveal reveal-delay-2 w-full overflow-hidden">
                    <OwlCarousel
                        ref={carouselRef}
                        className="owl-theme"
                        {...{
                            ...owlOptions
                        }}
                    >
                        {reviews.map((item) => (
                            <div
                                key={item.id}
                                className="item bg-white dark:bg-surface-dark p-6 md:p-10 rounded-3xl shadow-soft border border-gray-100 dark:border-gray-800 flex flex-col justify-between min-h-[300px] md:min-h-[350px] lg:min-h-[450px] xl:min-h-[400px] hover:shadow-hover transition-all duration-500 my-4"
                            >
                                <div>
                                    <div className="flex gap-1 text-primary mb-6 md:mb-8">
                                        {[...Array(item.rating)].map((_, i) => (
                                            <span key={i} className="material-symbols-outlined text-[20px] md:text-[22px] fill-current">star</span>
                                        ))}
                                    </div>
                                    <h5 className="text-[#0d121b] dark:text-white font-bold mb-2 font-display text-lg md:text-xl">{item.title}</h5>
                                    <p className="text-gray-700 dark:text-gray-300 text-base md:text-lg italic leading-relaxed font-medium">
                                        "{item.review}"
                                    </p>
                                </div>

                                <div className="flex items-center gap-4 md:gap-5 mt-8 md:mt-10">
                                    <div className="size-12 md:size-14 rounded-2xl bg-primary/10 overflow-hidden border border-primary/20 shrink-0">
                                        <img
                                            alt={item.name}
                                            className="w-full h-full object-cover"
                                            src={item.avatar}
                                        />
                                    </div>
                                    <div>
                                        <h4 className="font-bold text-[#0d121b] dark:text-white font-display text-base md:text-lg leading-tight">{item.name}</h4>
                                        <p className="text-[9px] md:text-[10px] text-primary font-black uppercase tracking-widest">{item.role}</p>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </OwlCarousel>
                </div>
            </div>
        </section>
    );
};

export default ReviewsSection;